import { Col, Skeleton } from "antd";
import React, { useEffect, useState } from "react";
import apiPath from "../../constants/apiPath";
import { useAppContext } from "../../context/AppContext";
import lang from "../../helper/langHelper";
import { Severty, ShowToast } from "../../helper/toast";

import useRequest from "../../hooks/useRequest";
import {
  UserQuarterlyChart,
  PickUpQuarterlyChart,
} from "../../components/chart/_YearlyChart";
import SectionWrapper from "../../components/SectionWrapper";

const dummy = {
  labels: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],
  datasets: [
    {
      label: "Dataset 1",
      data: [
        null,
        null,
        null,
        null,
        null,
        16000,
        null,
        5000,
        null,
        null,
        null,
        null,
      ], // Starting from June
      borderColor: "#F3E008",
      tension: 0.1,
      spanGaps: true, // Add this option
    },
    {
      label: "Dataset 2",
      data: [
        null,
        null,
        null,
        null,
        null,
        7000,
        null,
        8000,
        null,
        null,
        null,
        null,
      ], // Starting from June
      borderColor: "#383B42",
      backgroundColor: "rgba(53, 162, 235, 0.5)",
      spanGaps: true, // Add this option
      // yAxisID: 'y1',
    },
  ],
};

const YearlyChartSection = () => {
  const { country } = useAppContext();
  const { request } = useRequest();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [years, setYears] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [filter, setFilter] = useState({
    country_id: undefined,
    city_id: undefined,
    year: undefined,
    month: undefined,
  });



  const fetchData = () => {
    request({
      url: `${apiPath.dashboard}/graph?period=quarterly${filter.year ? `&year=${filter.year}` : ``
        }`,
      method: "GET",
      onSuccess: ({ data, status }) => {
        setLoading(false);
        console.log(data, "yearly");
        if (status) {
          setData(data);
          // const arr = [0, 0, 0, 0, 0, 0];
          // data.map(({ interval, count }) => {
          //   const findIndex = lastSixWeeks.findIndex(
          //     ({ weekNumber }) => weekNumber == parseInt(interval)
          //   );
          //   if (findIndex != -1) {
          //     arr[findIndex] = count;
          //   } else {
          //     arr[findIndex] = 0;
          //   }
          // });
          // console.log(arr, "llll");
          // setData(arr);
        }
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      {loading ? (
        [1, 2].map((item) => <Skeleton active key={item} />)
      ) : (
        <>
          {/* <p>{lang("Earnings")}</p> */}

          <Col xs={24} xl={12} lg={24} className="mb-24">
            <SectionWrapper
              cardHeading={lang("Bookings")}
              extra={
                <>
                  <div className="w-100 text-head_right_cont">
                    <div className="role-wrap"></div>
                  </div>
                </>
              }
            >
              <UserQuarterlyChart data={data?.bookings || []} />
            </SectionWrapper>
          </Col>

          <Col xs={24} xl={12} lg={24} className="mb-24">
            <SectionWrapper
              cardHeading={lang("Orders")}
              extra={
                <>
                  <div className="w-100 text-head_right_cont">
                    <div className="role-wrap"></div>
                  </div>
                </>
              }
            >
              <UserQuarterlyChart data={data?.orders || []} />
            </SectionWrapper>
          </Col>


        </>
      )}
    </>
  );
};

export default YearlyChartSection;
